
import { AxiosResponse } from "axios";
import NgongVegBanner from "@/components/NgongVegBanner";
import { computed, defineComponent, onMounted, ref } from "vue";
import http from "../../../../../common/services/http";
import { format } from "date-fns";

export default defineComponent({
  name: "Margins",
  components: { NgongVegBanner },
  setup() {
    const processing = ref(false);
    const downloadLoading = ref(false);

    const products = ref([]);
    const user_id = ref(0);
    const product = computed((): any => {
      return products.value?.find((c: any) => c.id == user_id.value);
    });

    const margins = ref({});

    function fetchCustomers() {
      processing.value = true;
      http.get(`/api/products?fetch=all`).then(res => {
        products.value = res.data;
        processing.value = false;
      });
    }

    function fetchMargins(id: any) {
      processing.value = true;

      http.get(`/api/margins-by-product?product=${id}`).then(res => {
        margins.value = res.data;
        processing.value = false;
      });
    }

    function addCommas(value: number) {
      if (value !== undefined) {
        const value2dp = value.toFixed(2);
        return value2dp.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }

    function downloadReport(response: AxiosResponse<any>) {
      const fileUrl = window.URL.createObjectURL(response.data);
      const fileLink = document.createElement("a");
      const date = format(new Date(), "yyyy-MM-dd");
      let name;

      if (product !== undefined) {
        name = product.value?.name
      }

      if (name === undefined) {
        name = "Products"
      }

      fileLink.href = fileUrl;
      fileLink.setAttribute(
        "download",
        name + " Margins Report " + date + ".xlsx",
      );
      document.body.appendChild(fileLink);

      fileLink.click();

      downloadLoading.value = false;
    }

    function fetchMarginsExport(id?: any) {
      downloadLoading.value = true;
      if (id) {
        http
          .get(
            `/api/margins-by-product-report?product=${id}`,
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response)
          })
      } else {
        http
          .get(
            '/api/margins-by-product-report',
            {
              responseType: "blob"
            }
          ).then(response => {
            downloadReport(response)
          })
      }
    }

    onMounted(() => {
      fetchCustomers();
    });

    return {
      user_id,
      product,
      products,
      fetchMargins,
      margins,
      processing,
      addCommas,
      downloadLoading,
      fetchMarginsExport,
    };
  }
});
